import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=21321742&scoped=true"
import script from "./pay.vue?vue&type=script&lang=js"
export * from "./pay.vue?vue&type=script&lang=js"
import style0 from "./pay.vue?vue&type=style&index=0&id=21321742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21321742",
  null
  
)

export default component.exports